module.exports = __webpack_public_path__ + "static/media/admin-right.bcb5752c.jpg";